"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrderOrderInnerToJSON = exports.ConfirmOrderOrderInnerFromJSONTyped = exports.ConfirmOrderOrderInnerFromJSON = exports.instanceOfConfirmOrderOrderInner = void 0;
var runtime_1 = require("../runtime");
var ConfirmOrderOrderInnerDetails_1 = require("./ConfirmOrderOrderInnerDetails");
var ConfirmOrderOrderInnerName_1 = require("./ConfirmOrderOrderInnerName");
var ConfirmOrderOrderInnerStatus_1 = require("./ConfirmOrderOrderInnerStatus");
/**
 * Check if a given object implements the ConfirmOrderOrderInner interface.
 */
function instanceOfConfirmOrderOrderInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfConfirmOrderOrderInner = instanceOfConfirmOrderOrderInner;
function ConfirmOrderOrderInnerFromJSON(json) {
    return ConfirmOrderOrderInnerFromJSONTyped(json, false);
}
exports.ConfirmOrderOrderInnerFromJSON = ConfirmOrderOrderInnerFromJSON;
function ConfirmOrderOrderInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : (0, ConfirmOrderOrderInnerName_1.ConfirmOrderOrderInnerNameFromJSON)(json['name']),
        'details': !(0, runtime_1.exists)(json, 'details') ? undefined : (0, ConfirmOrderOrderInnerDetails_1.ConfirmOrderOrderInnerDetailsFromJSON)(json['details']),
        'quantity': !(0, runtime_1.exists)(json, 'quantity') ? undefined : json['quantity'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, ConfirmOrderOrderInnerStatus_1.ConfirmOrderOrderInnerStatusFromJSON)(json['status']),
    };
}
exports.ConfirmOrderOrderInnerFromJSONTyped = ConfirmOrderOrderInnerFromJSONTyped;
function ConfirmOrderOrderInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': (0, ConfirmOrderOrderInnerName_1.ConfirmOrderOrderInnerNameToJSON)(value.name),
        'details': (0, ConfirmOrderOrderInnerDetails_1.ConfirmOrderOrderInnerDetailsToJSON)(value.details),
        'quantity': value.quantity,
        'status': (0, ConfirmOrderOrderInnerStatus_1.ConfirmOrderOrderInnerStatusToJSON)(value.status),
    };
}
exports.ConfirmOrderOrderInnerToJSON = ConfirmOrderOrderInnerToJSON;
